import { render, staticRenderFns } from "./StandingsTopPane.vue?vue&type=template&id=48b55ee4&scoped=true"
import script from "./StandingsTopPane.vue?vue&type=script&lang=ts"
export * from "./StandingsTopPane.vue?vue&type=script&lang=ts"
import style0 from "./StandingsTopPane.vue?vue&type=style&index=0&id=48b55ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b55ee4",
  null
  
)

export default component.exports